import React from "react";

export default function QubitPanel({
  probs,
  is2Qubit,
  onH,
  onX,
  onZ,
  onCNOT,
  onCZ,
  onSWAP,
  onMeasure,
  onReset,
  nQubits
}) {
  return (
    <div className="panel">
      <div className="quantum-controls-panel">
        <button onClick={onH}>Hadamard (H)</button>
        <button onClick={onX}>Pauli-X (NOT)</button>
        {nQubits === 1 && <button onClick={onZ}>Pauli-Z (Z)</button>}{" "}
        {is2Qubit && (
          <>
            <button onClick={onCNOT} disabled={probs.length < 4}>
              Controlled-NOT (CNOT)
            </button>
            <button onClick={onCZ}>Controlled-Z (CZ)</button>
            <button onClick={onSWAP}>SWAP</button> {/* NEW */}
          </>
        )}
        <button onClick={onMeasure}>Measure</button>
        <button onClick={onReset}>Reset</button>
      </div>

      <div className="probs">
        {probs.map((p, idx) => (
          <div key={idx} className="prob">
            <div
              className="bar"
              style={{ height: `${Math.round(p * 100)}%` }}
            />
            <span className="ket">
              |{idx.toString(2).padStart(Math.log2(probs.length), "0")}〉
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
